import React from 'react';
import './RelatedLocations.css';

const relatedLocations = [
  {
    id: 1,
    name: 'Baby Supplies Store',
    type: 'Shopping',
    distance: '0.3 miles',
    rating: 4.6,
    reviews: 89,
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400&h=300&fit=crop',
    amenities: ['Nursing Room', 'Changing Table'],
  },
  {
    id: 2,
    name: 'Little Explorers Park',
    type: 'Park & Play',
    distance: '0.5 miles',
    rating: 4.9,
    reviews: 215,
    image: 'https://images.unsplash.com/photo-1566454825481-9c31f9b5f9d6?w=400&h=300&fit=crop',
    amenities: ['Play Area', 'Restrooms'],
  },
  {
    id: 3,
    name: 'Family Health Clinic',
    type: 'Healthcare',
    distance: '0.8 miles',
    rating: 4.8,
    reviews: 156,
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=400&h=300&fit=crop',
    amenities: ['Pediatric Care', 'Changing Table'],
  },
  {
    id: 4,
    name: 'Tiny Tots Restaurant',
    type: 'Restaurant',
    distance: '1.2 miles',
    rating: 4.5,
    reviews: 178,
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400&h=300&fit=crop',
    amenities: ['High Chairs', 'Kids Menu'],
  },
];

const RelatedLocations = () => (
  <div className="related-locations">
    <h2 className="related-title">Explore nearby baby-friendly spots</h2>
    <div className="related-grid">
      {relatedLocations.map((loc) => (
        <a key={loc.id} href={`/location/${loc.id}`} className="related-card">
          <div className="related-card__image-container">
            <img src={loc.image} alt={loc.name} className="related-card__image" />
            <span className="related-card__distance">{loc.distance}</span>
          </div>
          <div className="related-card__content">
            <div className="related-card__header">
              <span className="related-card__type">{loc.type}</span>
              <span className="related-card__rating">
                <span className="star">★</span> {loc.rating}
              </span>
            </div>
            <h3 className="related-card__name">{loc.name}</h3>
            <div className="related-card__amenities">
              {loc.amenities.map((a, idx) => (
                <span key={idx} className="amenity-tag">{a}</span>
              ))}
            </div>
          </div>
        </a>
      ))}
    </div>
  </div>
);

export default RelatedLocations;
